import { useStanQuery } from '.';
import { fetchUser } from '@/lib/api/user';
import { useMemo } from 'react';
import { isAxiosError } from 'axios';
import { QUERY_KEYS } from '@/lib';
import { debounce } from 'lodash';
import { useAuthStore } from '@/stores';

export function useUser() {
    // dont make user calls if we arent authenticated
    const enabled = useAuthStore(state => state.isAuthenticated);
    const token = useAuthStore(state => state.token);
    const {
        data: user,
        isLoading: isUserLoading,
        error,
        refetch,
    } = useStanQuery(
        {
            queryKey: [QUERY_KEYS.USER, token],
            queryFn: () => fetchUser(token),
            staleTime: 1000 * 60 * 5, // 5 minutes
            structuralSharing: false, // Disable to ensure cache updates trigger re-renders
            enabled,
            retry: false,
            meta: { error: { sentryMessage: '[USER] failed-to-fetch-user' } },
        },
        true // Skip page loading - AuthProvider is global, pages should handle their own loading states
    );

    // add debounce to this call
    const refetchUser = useMemo(() => debounce(refetch, 300), [refetch]);

    if (isAxiosError(error) && error.response?.status === 401) {
        // Let auth store handle token cleanup
        throw error;
    }

    return { user, isUserLoading, refetchUser, error };
}
